export default __webpack_public_path__ + "static/media/crypto.fffcb109.png";